module.exports = __webpack_public_path__ + "img/voucher-hero-592422a.jpg";